import { css } from 'emotion';

export default {
	header: css`
		padding-right: 20px;
	`,
	wrapper: css`
		position: relative;
		white-space: nowrap;
	`,
	filterIcon: css`
		position: absolute;
		right: 0;
	`,
	filterWrapper: css`
		margin-top: 10px;
		display: flex;
		align-items: center;
		> *:first-child {
			flex-grow: 1;
		}
		> *:last-child {
			flex-grow: 0;
		}
	`,
	dateWrapper: css`
		display: flex;
		align-items: center;

		> *:first-child {
			width: auto !important;
			min-width: auto !important;
		}

		.DayPickerInput > input {
			margin-left: 5px;
			margin-right: 5px;
			border: 1px solid rgba(34, 36, 38, 0.15);
			border-radius: 0.28571429rem;
			padding: 0.67857143em 1em;
			width: 120px;

			&:focus {
				outline: 0;
				border-color: #96c8da;
			}
		}
	`,
	selectWrapper: css`
		display: flex;
		align-items: center;

		> *:last-child {
			margin-left: 5px;
		}
	`,
	textWrapper: css`
		display: flex;
		align-items: center;

		input {
			width: 120px;
		}

		> *:last-child {
			margin-left: 5px;
		}
	`
};



// WEBPACK FOOTER //
// ./src/components/SortByField/styles.js